import ApiService from "@/services/ApiService";

class LookupsService {
  lookupFiscalCode(fiscalCode) {
    return ApiService.get("/usr/v2/lookups/fiscal-code", {
      fiscalCode
    });
  }

  checkAddress(req) {
    return ApiService.post("/usr/v2/lookups/address/check", req);
  }

  getCountries() {
    return ApiService.get("/usr/v2/lookups/countries?size=250");
  }
  getProvinces(skipAbolished = false) {
    const url = `/usr/v2/lookups/provinces?size=150${skipAbolished ? "&abolished=false" : ""}`;
    return ApiService.get(url);
  }
  getStreetsInfo(req) {
    return ApiService.get("/usr/v2/lookups/streets", req);
  }
}

export default new LookupsService();
